import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ExpansionPanelComponent} from './expansion-panel.component';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatIconModule} from '@angular/material/icon';

@NgModule({
  declarations: [ExpansionPanelComponent],
  imports: [CommonModule, MatExpansionModule, MatIconModule],
  exports: [ExpansionPanelComponent],
})
export class ExpansionPanelModule {}
